.skeleton {
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  padding: 30px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}

#loader-1 {
  width: 68px;
  height: 68px;
  fill: #FF6700;
}

.skeleton-item {
  height: 16px;
  width: 100%;
  list-style: none;
  margin-bottom: 16px;

  background: linear-gradient(90deg, rgba(0, 0, 0, 0.06) 25%, rgba(0, 0, 0, 0.15) 37%, rgba(0, 0, 0, 0.06) 63%);
  background-size: 400% 100%;
  animation-name: skeleton-loading;
  animation-duration: 1.4s;
  animation-timing-function: ease;
  animation-iteration-count: infinite;
}
@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}

.skeleton-item-middle {
  height: 30px;
}
.skeleton-item-large {
  height: 60px;
}
.skeleton-item-img svg {
  width: 48px;
  height: 48px;
  fill: #bfbfbf;
}
.skeleton-item-img {
  width: 96px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: top;
  border-radius: 4px;
}




.comment-overview {
  display: flex;
  width: 100%;
  border-bottom: 0.9px solid #d4d4d4 !important;
}

.comment-overview-item {
  flex: 1;
  padding: 20px;
}
.items-center {
  display: flex;
  align-items: center;
}


.skeleton-comment-list {
  width: 100%;
  margin-top: 50px;
}
.skeleton-comment-item {
  padding: 20px 0;
  border-bottom: solid 1px #d4d4d4;
}
.comment-item-rate {
  margin-bottom: 32px;
}
.img-list {
  display: flex;
  column-gap: 8px;
  margin-top: 32px;
}

@media screen and (max-width: 1024px) {
  .comment-overview {
    flex-direction: column;
  }

  .comment-overview .comment-overview-item:first-child .skeleton-item {
    margin: 0 auto;
    margin-bottom: 10px;
    width: 55%!important;
  }
  .comment-overview .comment-overview-item:first-child {
    padding-bottom: 0;
  }
  .comment-overview .comment-overview-item:last-child {
    display: none;
  }

  .skeleton-comment-list {
    margin-top: 25px;
  }
  .skeleton {
    max-width: 100%;
    padding: 0;
  }
  .skeleton-item-img {
    width: 76px;
    height: 76px;
  }
}